import { render, staticRenderFns } from "./WhiteNoiseAudio.vue?vue&type=template&id=6be56c38&scoped=true&"
import script from "./WhiteNoiseAudio.vue?vue&type=script&lang=js&"
export * from "./WhiteNoiseAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be56c38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be56c38')) {
      api.createRecord('6be56c38', component.options)
    } else {
      api.reload('6be56c38', component.options)
    }
    module.hot.accept("./WhiteNoiseAudio.vue?vue&type=template&id=6be56c38&scoped=true&", function () {
      api.rerender('6be56c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/WhiteNoiseAudio.vue"
export default component.exports